import { AxiosError } from "axios";
import { showNotification } from "../../../../../common/actionCreators/dispatchNotification";
import apiClient from "../../../../../common/api/apiClient";
import { ApiError } from "../../../../../common/api/apiResponse";
import { HoursDto } from "./hours.dtos";

const hoursUrl = '/visitorInformation/hours/';

export const getDaysApi = async () => {
    return await apiClient.get(hoursUrl)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving days.', 'error');
        }
        throw err;
    });
};

export const getDayApi = async (request: string) => {
    return await apiClient.get(hoursUrl + request)
    .then((res) => {
        return res.data.result;
    })
    .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            console.log("response: ", axiosError.response)
            showNotification(axiosError.response?.data?.error?.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while retrieving day.', 'error');
        }
        throw err;
    });
};

export const updateDayApi = async (request: HoursDto) => {
    return await apiClient.put(hoursUrl, request)
      .then((res) => {
        showNotification("Day updated", 'success');
        return res.data.result;
      })
      .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while updating day.', 'error');
        }
        throw err;
      });
};

export const createDayApi = async (request: HoursDto) => {  
    return await apiClient.post(hoursUrl, request)
      .then((res) => {
        showNotification("Day created", 'success');
        return res.data.result;
      })
      .catch((err) => {
        console.log('In error', err);
        if (err && err.response) {
          const axiosError = err as AxiosError<ApiError>;
          if (axiosError.response) {
            showNotification(axiosError.response.data.error.message, 'error');
          }
        }
        else {
          showNotification('An error occurred while creating day.', 'error');
        }
        throw err;
      });
};

export const deleteDayApi = async (day: HoursDto) => {
  return await apiClient.delete(hoursUrl + day.id)
  .then((res) => {
    showNotification("Day deleted", 'success');
    return res.data.result;
  })
  .catch((err) => {
    if (err && err.response) {
      const axiosError = err as AxiosError<ApiError>;
      if (axiosError.response) {
        showNotification(axiosError.response.data.error.message, 'error');
      }
    }
    else {
      showNotification('An error occurred while deleting day.', 'error');
    }
    throw err;
  });
}